// UI texts: prepare
export default {
  title: 'Prepare expedition',
  orders: 'Orders',
  form: 'Form 7-B · Survivor: {name} · Lv {n}',
  draft: 'Draft',
  blocked: 'On hold',
  destination: 'Destination',
  energyN: '{n} energy',
  // 01 duration
  duration: 'Duration',
  durationSub: 'Longer runs find more, and meet more',
  /** 2. 10. 2026: by the run's length (shared `durationName`), no longer by the button's place. */
  /** 3. 10. 2026: 10 Very short · 20 Short · 40 Medium · 60 Long · 120 Extended · 240 Very long · 480 Overnight. */
  durLabel: { veryShort: 'Very short', short: 'Short', medium: 'Medium', long: 'Long', extended: 'Extended', veryLong: 'Very long', overnight: 'Overnight' },
  // 02 stance
  stance: 'Stance',
  stanceSub: 'How {name} treats other survivors',
  ordered: 'Ordered',
  risk: 'Risk',
  lootMeter: 'Loot',
  ambush: 'Ambush style',
  steal: 'Steal',
  attack: 'Attack',
  stealHint: 'Grab the loot and run. No fight if it goes well.',
  attackHint: 'Fight for everything they carry. More loot, more blood on the boots.',
  // 03 retreat
  retreat: 'Retreat at',
  retreat50: '50% HP',
  retreat25: '25% HP',
  retreatNever: 'Fight to the end',
  /** Tooltip and full name of the option (krug 3, L6 / O8). */
  retreatNeverFull: 'Fight to the end (flees at 15% HP)',
  retreatHint: {
    '50': 'Comes home early. Keeps HP, misses some loot.',
    '25': 'Pushes on until badly hurt, then heads back.',
    /** 4. 10. 2026 (owner decision): a knockout is a meant risk of this line. */
    never: 'Never turns back. Flees a fight only at 15% HP, so a knockout is possible.',
  },
  hpNow: 'HP now',
  turnsBack: 'turns back at {n} HP',
  noTurnBack: 'never turns back · flees a fight at {n} HP',
  // 04 trade
  trade: 'Trade',
  tradeSub: 'Used when a stranger agrees',
  offer: 'I offer',
  want: 'I want',
  nothing: 'nothing',
  offerNote: 'Each offered good packs {n} units from storage into the backpack.',
  // 05 supplies
  supplies: 'Supplies',
  /** Krug 5 (K12.11): one meal before the run. */
  meal: 'Meal',
  mealSub: 'One meal, eaten as the run leaves',
  /** Package 4, part O. */
  mealSubTier: 'One meal, eaten as the run leaves · T{tier} meals',
  mealSuggest: 'Suggested: {name}. {why}',
  mealHorde: 'A horde tonight: eat a Horde Ration when you join it.',
  mealNone: 'None',
  mealNoneSub: 'Go out on an empty stomach',
  noMeal: 'No meal.',
  cookOne: 'Cook one at the Workshop.',
  suppliesSub: 'Taken from storage',
  /** 7. 10. 2026 (owner, Ammo per shot): `s` the shots a fight takes in the zone. */
  feedAmmo: '1 per shot · ~{n} fights × ~{s} shots · taking {take}',
  feedAmmoOne: '1 per shot · ~1 fight × ~{s} shots · taking {take}',
  feedFuel: '1 per fight · ~{n} fights expected · taking {take}',
  feedFuelOne: '1 per fight · ~1 fight expected · taking {take}',
  feedShort: 'Not enough for every fight: −30% damage once it runs out',
  /** 7. 10. 2026 (owner): the truck. */
  truck: 'Take the truck',
  /** Round 2 (7. 10. 2026): the pack's room with the truck. */
  truckSub: 'Pack room {a} → {b} · {f} Fuel (you have {n})',
  truckShort: 'Needs {f} Fuel. You have {n}.',
  /** 7. 10. 2026: Ammo rides in the pouches (no pack room). */
  feedPouch: 'In the pouches: takes no pack room',
  /** 2. 10. 2026 (package 1, 9.a): the bandage line, from the expected fights (~15% HP each). */
  fights: '~{n} fights',
  fightsOne: '~1 fight',
  hpLoss: '~{p}% HP',
  bandageNone: 'no Bandages needed',
  bandageOne: 'bring 1 Bandage',
  bandageMany: 'bring {k} Bandages',
  bandageShort: 'You have {n}. Craft more at the Workshop.',
  /** 7. 10. 2026 (owner, Loadout): the Medkit the sheet suggests on a run of 2 hours or longer. */
  medkitLong: 'bring 1 Medkit on a run of 2 h or longer',
  hpLine: 'HP {hp}/{max}',
  hpFullIn: 'full in {t}',
  packLeft: 'Your pack is still full: {used}/{cap}. Make room in Storage first.',
  packLeftOpen: 'Open inventory',
  /** 30. 9. 2026: the chosen run's loot would not fit. */
  packFills: 'Your pack fills in about {time} here, then your survivor turns back.',
  /** 3. 10. 2026 (package 2, 5.a): a run of 120 minutes or more goes on with a full pack. */
  longRun: "Long run: a full pack won't send your survivor home, and they rest on quiet stretches.",
  packFillsLong: 'Your pack fills in about {time} here. After that, finds turn into Scrap and your survivor keeps searching for gear and keys.',
  /** 4. 10. 2026 (package 3, L and D). */
  packFillsSwap: 'Pack fills at ~{time}. After that your survivor keeps the most valuable finds.',
  seasonEnds: 'This run ends after the season does. It brings nothing back.',
  seasonEndsSoon: 'Season {n} ends at {time}. A run that would end later cannot go.',
  /** 28. 10. 2026 (owner, players' feedback): the chosen run is still out when tonight's horde starts, and no guard is paid. */
  hordeOut: "This run is still out at {time}: stand guard to take part in tonight's horde.",
  hordeOutLink: 'Stand guard',
  /** 9.b2: the find at the end of a run that stays out its whole time, with its chance for the chosen duration. */
  cacheHint: 'Stay out the full time: {p}% chance of a find at the end.',
  freeFromPerk: 'Free from a perk: {what}',
  inStorage: '{n} in storage',
  effect: {
    bandage: 'Heals 50 HP when hurt',
    medkit: 'Heals 200 HP when hurt',
    painkillers: '+20% defense this run',
    stim: '+3 AGI this run',
    /** 7. 10. 2026 (owner): Hollow-point Rounds and the Molotov. */
    hollow_point: '+10% firearm damage this run',
    molotov: 'Thrown at the start of an NPC fight: burns 2 rounds',
  },
  less: 'Fewer {name}',
  more: 'More {name}',
  // revenge
  revenge: 'Revenge',
  revengeSub: 'Raises the odds of meeting them',
  noRevenge: 'No target',
  hunt: 'Hunt {name}',
  revengeMeta: 'Lv {n} · {bg}',
  lastSeen: 'last seen at {zone}',
  /** Package 4, part E (6): where the target is now. */
  huntRun: 'out in {zone} now',
  huntTracks: 'tracks in {zone}',
  huntNone: 'out of reach now',
  /** Package 4, part E (3): worn items a winner could take on this run. */
  atRisk: 'At risk: {n} unlocked items. A survivor who beats you can take one.',
  atRiskOne: 'At risk: 1 unlocked item. A survivor who beats you can take it.',
  atRiskValuable: 'Unlocked and valuable: {names}.',
  atRiskLock: 'Lock slots',
  expiresIn: 'expires in {t}',
  // 06 backpack
  backpack: 'Backpack',
  packHint: 'A full backpack lowers escape chance. Room for {n} more.',
  packFull: 'Over capacity by {n}. Your survivor will struggle to run.',
  // footer
  recapRetreat: 'retreat at {v}',
  recapNever: 'fight to the end (flees at 15% HP)',
  recapCarried: '{a}/{b} carried',
  send: 'Send survivor',
  /** Krug 5 (K17.3): the chosen duration costs more energy than there is. */
  notEnough: 'Not enough energy · +1 in {t}',
  canStill: 'You can still go for {m}',
  sending: 'Sending…',
  checks: 'Before you go',
  sent: '{name} left for {zone}',
  back: 'Back to the map',
  notFound: 'This place is not on any map we have.',
} as const;
